<template>
  <v-container fluid>
    <v-row dense class="d-flex" style="height: 50px;">
      <v-col md="auto">
        <v-btn
          rounded
          small
          fab
          color="primary"
          class="add-button-fab mb-2"
          @click.stop="add_process"
          :disabled=!isAdmin
          >
          <v-icon small>mdi-plus-thick</v-icon>
        </v-btn>
      </v-col>
      <v-col
        style="align-content: center; flex-grow: 1;"
        md="auto"
        
      >
        <ViewTitle title="Process"/>
      </v-col>
      <v-col
        md="auto"
      >
        <SearchTextAdmin
          @input="setSearchText"
          @output="setSearchText"
        />
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="items"
      item-class="qmkey-item-row"
      :search="search"
      :expanded="expanded"
      fixed
      small
      dense
      show-expand
      @update:expanded="update_expand"
    >
      <template v-slot:item.name="{item}">
        <b v-if="item.name && items_tree" class="text-success">{{item_tree_level(item)+' '+item.name}}</b>
      </template>
      <template v-slot:item.inherit_permissions="{item}">
        <b v-if="item.inherit_permissions" class="text-success">✔</b>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          :disabled="!isAdmin"
          @click="add_process(item)"
        >
          mdi-plus
        </v-icon>
        <v-icon
          small
          class="mr-2"
          :disabled="!isAdmin"
          @click="edit_process(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          icon
          class="mr-2"
          :disabled="!isAdmin || (item.children && item.children.length > 0)"
          @click="delete_process(item)"
        >
          mdi-trash-can-outline
        </v-icon>
      </template>
      <template v-slot:expanded-item="{ item }">
        <td
          :colspan="headers.length +1"
          class="qmkey-explorer-table-expansion-td"
        >
        <v-container fluid>
          <ProcessData
            ref="data"
            :process="item"
            :roles="roles"
            :departments="departments"
            @refresh="refresh"
          />
        </v-container>
          
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>
  
<style lang="scss">
</style>
  
<script>
  import { mapGetters } from 'vuex'
  import QTree from '@/utils/QTree'
  import ViewTitle from '@/components/ViewTitle'
  import SearchTextAdmin from '@/components/header/SearchTextAdmin'
  import ProcessData from '@/components/process/ProcessData'

  export default {
    name: 'ProcessTable',
  
    components: {
      ViewTitle,
      SearchTextAdmin,
      ProcessData,
    },

    props: {
      processes: {default: () => ({})},
      processes_types: {default: () => ([])},
      roles: {},
      departments: {},
    },
      
    data: () => ({
      search: null,
      expanded: [],
    }),
  
    computed: {
      ...mapGetters(['isAdmin','sitePath']),
      items_tree() {
        let v = new QTree(this.processes.children.map(it => it.children).flat())
        return v;
      },
      items() {
        return this.items_tree.plain_tree().filter(it => !it.static) || []
      },
      headers() {
        return [
          {
            text: this.$vuetify.lang.translator('views.processes.process_fields.name'),
            align: 'start',
            sortable: false,
            value: 'name',
          },{
            text: this.$vuetify.lang.translator('views.processes.process_fields.process_id'),
            align: 'start',
            sortable: false,
            value: 'id',
          },{
            text: this.$vuetify.lang.translator('views.processes.process_fields.process_type'),
            align: 'start',
            sortable: false,
            value: 'get_process_type_display',
          },{
            text: this.$vuetify.lang.translator('views.processes.process_fields.parent'),
            align: 'start',
            sortable: false,
            value: 'parent_name',
          },{
            text: this.$vuetify.lang.translator('views.processes.process_fields.inherit_permissions'),
            align: 'center',
            sortable: false,
            value: 'inherit_permissions',
          },{
            text: '',
            align: 'start',
            sortable: false,
            value: 'actions',
          },{
            text:'',
            align: 'start',
            sortable: false,
            value: "data-table-expand",
            filterable: false,
          }
      ]
      },
    },

    methods: {
      add_process(item) {
        this.$emit('add_process',item)
      },
      edit_process(item) {
        this.$emit('edit_process',item)
      },
      delete_process(item) {
        this.$emit('delete_process',item)
      },

      item_tree_level(item) {
        let path_length = this.items_tree.path(item.id).length - 1
        if (path_length > 0) {
          return Array.from(Array(path_length).keys()).map(() => '- ').reduce((a,b)=> {return a+b})
        } else {
          return '';
        }
      },

      setSearchText(text) {
        this.search = text;
      },
      
      update_expand(expand) {
        this.expanded = expand;
      },
      refresh() {
        this.$emit('refresh');
      },
    },
  
  }
</script>